import {
  Component,
  Input,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tooltip-container" [class]="'tooltip-' + position">
      <div class="tooltip-content">
        @if (isTemplate) {
          <ng-container *ngTemplateOutlet="template"></ng-container>
        } @else {
          {{ content }}
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() content: string = '';
  @Input() template: TemplateRef<unknown> | null = null;
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';

  get isTemplate(): boolean {
    return this.template !== null;
  }
}
